import { Component } from '@theme/component';

// Índice del chip "Mi pedido" — al seleccionarlo aparece el campo de nº de pedido.
const ORDER_TOPIC_INDEX = 2;

/**
 * PPZ Contact Form
 *
 * Los chips de "Asunto" son solo presentación: al hacer clic, actualizan
 * un input oculto (contact[Asunto]) que sí viaja con el envío real del
 * formulario nativo de Shopify, y muestran/ocultan el campo de nº de
 * pedido cuando el asunto es "Mi pedido".
 *
 * @typedef {object} Refs
 * @property {HTMLInputElement} topicInput
 * @property {HTMLElement} orderField
 *
 * @extends {Component<Refs>}
 */
export class PpzContactForm extends Component {
  requiredRefs = ['topicInput', 'orderField'];

  #controller = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#controller;

    for (const chip of this.querySelectorAll('.ppz-topic-chip')) {
      chip.addEventListener('click', this.#handleChipClick, { signal });
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller.abort();
  }

  /** @param {MouseEvent} event */
  #handleChipClick = (event) => {
    const chip = /** @type {HTMLElement} */ (event.currentTarget);
    const index = Number(chip.dataset.index);

    for (const active of this.querySelectorAll('.ppz-topic-chip.is-active')) {
      active.classList.remove('is-active');
    }

    chip.classList.add('is-active');
    this.refs.topicInput.value = chip.textContent.trim();
    this.refs.orderField.hidden = index !== ORDER_TOPIC_INDEX;
  };
}

if (!customElements.get('ppz-contact-form')) {
  customElements.define('ppz-contact-form', PpzContactForm);
}
